/**
* 提现详情
*/
<template>
	<div style="display: flex;flex-direction: column; height: 100vh; margin: 0px 20px;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<!-- 拒绝的提示框 需要输入拒绝原因 -->
		<el-dialog title="请输入拒绝原因" :visible.sync="dialogRejecte">
			<el-input placeholder="请输入原因" v-model="pretestResult">
				<template slot="prepend">原因:</template>
			</el-input>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogRejecte = false">取消拒绝</el-button>
				<el-button type="primary" @click="savePretestResult(2)">确定拒绝</el-button>
			</div>
		</el-dialog>


		<el-descriptions title="用户信息" style="padding: 20px; 10px" direction="vertical" :column="6" border>
			<template slot="extra">
				<el-button v-show="data.withdrawStatus==0" type="danger" size="small"
					@click="dialogRejecte = true">拒绝</el-button>
				<el-button v-show="data.withdrawStatus==0" type="success" size="small"
					@click="savePretestResult(1)">同意</el-button>
			</template>
			<el-descriptions-item label="申请时间">{{ data.createTime }}</el-descriptions-item>
			<el-descriptions-item label="用户ID">{{ data.userId }}</el-descriptions-item>
			<el-descriptions-item label="提现金额">
				<el-tag size="small">{{ data.withdrawAmount }}</el-tag>
			</el-descriptions-item>
			<el-descriptions-item label="币种">
				<el-tag size="small">{{ data.currency }}</el-tag>
			</el-descriptions-item>
			<el-descriptions-item label="审核状态">
				<!-- //0审核中 1已通过 2未通过 3已完成 -->
				<p v-show="data.withdrawStatus==0" style="font-size: 14px; color: #0000FF;">审核中</p>
				<p v-show="data.withdrawStatus==1" style="font-size: 14px; color: #008000;">已通过</p>
				<p v-show="data.withdrawStatus==2" style="font-size: 14px; color: #FF0000;">未通过</p>
				<p v-show="data.withdrawStatus==3" style="font-size: 14px; color: #008000;">已完成</p>
			</el-descriptions-item>
			<el-descriptions-item label="打款凭证">
				<!-- <a v-show="data.withdrawStatus==3" :href="data.paymentVoucherImg" target="_blank">
					<img :src="data.paymentVoucherImg" :alt="data.paymentVoucherImg"
						style="width: 94px; height: auto;" />
				</a> -->
				<div v-show="data.withdrawStatus == 3">
					<a v-for="(img, index) in paymentVoucherImages" :key="index" :href="img" target="_blank">
						<img :src="img" :alt="img" style="width: 94px; height: auto; margin-right: 8px;" />
					</a>
				</div>
			</el-descriptions-item>
		</el-descriptions>


		<div style="width: 100px; padding-left: 20px;">
			<el-button v-show="data.withdrawStatus==1" type="primary" size="small" @click="submit()">上传打款凭证</el-button>
		</div>

		<!-- 上传图片 -->
		<el-upload v-show="data.withdrawStatus==1" style="padding-top: 10px; padding-left: 20px; padding-bottom: 20px;"
			action="http://baidu.com/" list-type="picture-card" :auto-upload="false" :file-list="fileList"
			:on-change="handleChange">
			<i slot="default" class="el-icon-plus"></i>
			<div slot="file" slot-scope="{file}">
				<img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
				<span class="el-upload-list__item-actions">
					<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
						<i class="el-icon-zoom-in"></i>
					</span>
					<span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
						<i class="el-icon-delete"></i>
					</span>
				</span>
			</div>
		</el-upload>

		<!-- 图片展示 -->
		<el-dialog :visible.sync="dialogVisible">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>

		<!-- 实名认证的信息 -->
		<el-descriptions title="实名认证信息" style="padding: 20px; 10px" direction="vertical" :column="5" border>
			<el-descriptions-item label="真实姓名">{{ data.realName }}</el-descriptions-item>
			<el-descriptions-item label="身份证号码">{{ data.idCardNo }}</el-descriptions-item>

			<el-descriptions-item label="身份证正面">
				<a :href="data.cardFrontImg" target="_blank">
					<img :src="data.cardFrontImg" :alt="data.cardFrontImg"
						style="width: 100px; height: 100px; object-fit: contain;" />
				</a>
			</el-descriptions-item>

			<el-descriptions-item label="身份证反面">
				<a :href="data.cardBackImg" target="_blank">
					<img :src="data.cardBackImg" :alt="data.cardBackImg"
						style="width: 100px; height: 100px; object-fit: contain;" />
				</a>
			</el-descriptions-item>

			<!-- <el-descriptions-item label="手持身份证">
				<a :href="data.cardHandImg" target="_blank">
					<img :src="data.cardHandImg" :alt="data.cardHandImg"
						style="width: 100px; height: 100px; object-fit: contain;" />
				</a>
			</el-descriptions-item> -->
		</el-descriptions>



		<!-- 国内卡信息展示 -->
		<el-descriptions v-show="data.bankType=='0'" title="银行卡信息" style="padding: 20px; 10px" direction="vertical"
			:column="5" border>
			<el-descriptions-item label="收款类型">国内卡</el-descriptions-item>
			<el-descriptions-item label="收款账户">{{ data.accountNum }}</el-descriptions-item>
			<el-descriptions-item label="银行名称">{{ data.bankName }}</el-descriptions-item>
			<el-descriptions-item label="支行名称">{{ data.bankSubName }}</el-descriptions-item>
			<!-- <el-descriptions-item label="银行卡照片"><img :src="data.bankImg" :alt="data.bankImg"
					style="width: 100px; height: 100px; object-fit: contain;" /></el-descriptions-item> -->
		</el-descriptions>


		<!-- 国外卡信息展示 -->
		<el-descriptions v-show="data.bankType=='1'" title="银行卡信息" style="padding: 20px; 10px" direction="vertical"
			:column="5" border>
			<el-descriptions-item label="收款类型">国外卡</el-descriptions-item>
			<el-descriptions-item label="收款账户">{{ data.accountNum }}</el-descriptions-item>
			<el-descriptions-item label="银行名称">{{ data.bankName }}</el-descriptions-item>
			<el-descriptions-item label="支行名称">{{ data.bankSubName }}</el-descriptions-item>
			<!-- <el-descriptions-item label="银行卡照片"><img :src="data.bankImg" :alt="data.bankImg"
					style="width: 100px; height: 100px; object-fit: contain;" /></el-descriptions-item> -->
			<el-descriptions-item label="SWIFT银行识别码">{{ data.swiftCode }}</el-descriptions-item>
			<el-descriptions-item label="银行结算代号">{{ data.bankSettlementCode }}</el-descriptions-item>
		</el-descriptions>


		<!-- 国外卡信息展示 收款人地址-->
		<el-descriptions v-show="data.bankType=='1'" title="收款人地址" style="padding: 20px; 10px" direction="vertical"
			:column="7" border>
			<el-descriptions-item label=" 国家">{{ data.bankUserCountry }}</el-descriptions-item>
			<el-descriptions-item label=" 城市">{{ data.bankUserCity }}</el-descriptions-item>
			<el-descriptions-item label=" 区域">{{ data.bankUserArea }}</el-descriptions-item>
			<el-descriptions-item label=" 街道">{{ data.bankUserStreet }}</el-descriptions-item>
			<el-descriptions-item label=" 大厦">{{ data.bankUserEdifice }}</el-descriptions-item>
			<el-descriptions-item label=" 楼层">{{ data.bankUserFloor }}</el-descriptions-item>
			<el-descriptions-item label=" 房间号">{{ data.bankUserRoom }}</el-descriptions-item>
		</el-descriptions>

		<!-- 国外卡信息展示 收款银行地址-->
		<el-descriptions v-show="data.bankType=='1'" title="收款银行地址" style="padding: 20px; 10px" direction="vertical"
			:column="7" border>
			<el-descriptions-item label=" 国家">{{ data.bankCountry }}</el-descriptions-item>
			<el-descriptions-item label=" 城市">{{ data.bankCity }}</el-descriptions-item>
			<el-descriptions-item label=" 区域">{{ data.bankArea }}</el-descriptions-item>
			<el-descriptions-item label=" 街道">{{ data.bankStreet }}</el-descriptions-item>
			<el-descriptions-item label=" 大厦">{{ data.bankEdifice }}</el-descriptions-item>
			<el-descriptions-item label=" 楼层">{{ data.bankFloor }}</el-descriptions-item>
			<el-descriptions-item label=" 房间号">{{ data.bankRoomNum }}</el-descriptions-item>
		</el-descriptions>


	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				dataReturn: null, //页面传递过来的数据
				data: null, //详情数据
				dialogRejecte: false, //拒绝提示框
				pretestResult: '', //拒绝的原因
				keyValuePairs: {}, // 存储键值对的对象(用来存图片的)
				newKey: '', // 新键的值 框架的url
				newValue: '', // 新值的值 后台返回的url
				fileList: [], // 用于存储上传的文件列表(这里是浏览器中的缓存图片)
				dialogImageUrl: '',
				dialogVisible: false,
				paymentVoucherImages: [
					"https://accelerate.qiuitoy.com/crmebimage/public/user/2024/10/23/9e1325cd086842208cbc84616ec9cfc3sqyxdy080r.png",
					"https://accelerate.qiuitoy.com/crmebimage/public/user/2024/10/23/91bd250c87c8438cb8a90b15ee9c80d0736rlajmld.png"
				]
			};
		},
		mounted() {
			// 解析传递过来的 JSON 字符串
			this.dataReturn = JSON.parse(this.$route.query.data);
			console.log("解析传递过来的：", this.dataReturn);
			this.getData(); //根据用户id查询语音房用户基础认证信息
		},
		methods: {
			getData() { //获取详情
				axios.get(this.$p_url + '/voiceRoom/H5/getH5VoiceRoomWithdrawRecordDetail/' + this.dataReturn.withdrawId, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						try {
							this.loadingData = false;
							console.log("获取详情 的返回：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.data = response.data.data;
								//身份证正面
								response.data.data.cardFrontImg = this.$p_urlImage + response.data.data.cardFrontImg;
								//身份证反面
								response.data.data.cardBackImg = this.$p_urlImage + response.data.data.cardBackImg;
								//手持身份证
								response.data.data.cardHandImg = this.$p_urlImage + response.data.data.cardHandImg;
								//银行卡照片
								response.data.data.bankImg = this.$p_urlImage + response.data.data.bankImg;
								//打款凭证
								if (response.data.data.paymentVoucherImg != null)
									this.paymentVoucherImages = response.data.data
									.paymentVoucherImg.split(',').map(img => this.$p_urlImage + img);
							} else {
								alert("服务器错误:" + response.data.message)
							}
						} catch (error) {
							alert("获取详情 异常: " + error.message);
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
						console.error('Error fetching data:', error);
					});
			},
			savePretestResult(pretestStatus) { //操作申请接口
				this.dialogRejecte = false;
				const requestData = {}; //传递的参数
				if (pretestStatus == 2)
					requestData.notPassRes = this.pretestResult; //拒绝的原因
				requestData.operateFlag = pretestStatus; //操作意向 1通过 2未通过
				requestData.withdrawId = this.dataReturn.withdrawId; //提现申请id

				console.log('操作申请接口 传值', requestData);
				this.loadingData = true;
				axios.post(this.$p_url + '/voiceRoom/H5/operateVoiceRoomWithdrawRecord',
						requestData, {
							withCredentials: true,
							headers: {
								'Content-Type': 'application/json',
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
					.then(response => {
						try {
							this.loadingData = false;
							console.log("操作申请接口 的返回：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.getData(); //进行刷新
							} else {
								alert("服务器错误:" + response.data.message)
							}
						} catch (error) {
							alert("操作申请接口 异常: " + error.message);
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
						console.error('Error fetching data:', error);
					});
			},
			handleChange(file, fileList) { // 选择文件时触发
				this.fileList = fileList;

				const formData = new FormData(); // 创建一个 FormData 对象
				formData.append("multipart", file.raw); // 将文件添加到 FormData 对象中
				axios.post(this.$p_url_shop + '/api/front/upload/qiuiUploadImage?model=user&pid=1',
						formData, { //上传图片
							withCredentials: true,
							headers: {
								'Content-Type': 'multipart/form-data', //设置为上传文件的类型
							},
						})
					.then(response => {
						console.log("上传图片的返回：", response.data)
						const state = response.data.code; // 获取状态
						if (state === 200) { // 检查状态
							this.newKey = file.url;
							this.newValue = response.data.data.url;
							this.$set(this.keyValuePairs, this.newKey, this.newValue); // 添加新的键值对
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						alert('请求失败:' + error);
						console.error('Error fetching data:', error);
					});


			},
			handleRemove(file) { //删除图片
				console.log(file);

				const imageUrl = file.url; // 获取要删除的图片的 URL
				const imageKey = Object.keys(this.keyValuePairs).find(key => {
					const isMatch = key === imageUrl;
					return isMatch;
				});
				if (imageKey) { // 如果找到了对应的键
					const name = this.keyValuePairs[imageKey];
					console.log("对应的值:", name);

					const formData = new FormData(); // 创建一个 FormData 对象
					formData.append("imageName", name); //图片的路径
					axios.post(this.$p_url_shop + '/api/front/upload/deleteOssImage',
							formData, {
								withCredentials: true,
								headers: {
									'Content-Type': 'application/json',
									'Accept': '*/*',
								},
							})
						.then(response => {
							console.log("删除图片的返回：", response.data)
							const state = response.data.code;
							if (state === 200) {
								this.$delete(this.keyValuePairs, file.url); // 删除指定键的键值对

								// 更新 fileList，移除被删除的图片
								const index = this.fileList.indexOf(file);
								if (index !== -1) {
									this.fileList.splice(index, 1);
								}

							} else {
								alert("服务器错误:" + response.data.message)
							}
						})
						.catch(error => { // 请求失败时处理错误
							alert('请求失败:' + error);
							console.error('Error fetching data:', error);
						});
				}
			},
			submit() { //上传付款凭证
				let values = [];
				for (let key in this.keyValuePairs) { //上传的图片
					if (this.keyValuePairs.hasOwnProperty(key)) {
						console.log(`Key: ${key}, Value: ${this.keyValuePairs[key]}`);
						values.push(this.keyValuePairs[key]);
					}
				}
				let sysCheckImage001 = values.join(',');
				console.log("提交的图片路径", sysCheckImage001);

				const requestData = {}; //传递的参数
				requestData.paymentVoucherImg = sysCheckImage001;
				requestData.withdrawId = this.dataReturn.withdrawId; //提现申请id

				console.log('上传付款凭证 传值', requestData);
				this.loadingData = true;
				axios.post(this.$p_url + '/voiceRoom/H5/operateVoiceRoomPaymentVoucherImg',
						requestData, {
							withCredentials: true,
							headers: {
								'Content-Type': 'application/json',
								'Accept': '*/*',
								'token': Cookies.get("token"),
							},
						})
					.then(response => {
						try {
							this.loadingData = false;
							console.log("上传付款凭证 的返回：", response.data)
							const state = response.data.state; // 获取状态
							if (state === "success") { // 检查状态
								this.getData(); //进行刷新
							} else {
								alert("服务器错误:" + response.data.message)
							}
						} catch (error) {
							alert("上传付款凭证 异常: " + error.message);
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
						console.error('Error fetching data:', error);
					});

			},
			//...
		}
		//...

	}
</script>

<style>
</style>